export enum PackagesType {
  Packages = 'packages',
  Addons = 'addons',
}
